// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"DailyReportTrafficTable_totalRow_2aJvm"};